import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import { Provider } from "react-redux";
import { store } from "./store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </MantineProvider>
    </Provider>
  </BrowserRouter>
);
